import { apiCallCenter } from '@/plugins/axios'
import { hostname } from '@/utils/hostname'


export default {
  postRelatorioDisponibilidadeResumido(data) {
    return apiCallCenter().post('/relatorios/disponibilidade/operadores/resumido?_method=GET', data)
  },
  postRelatorioDisponibilidadeResumidoInformacaoGeral(data) {
    return apiCallCenter().post('/relatorios/disponibilidade/operadores/resumido/total?_method=GET', data)
  },
  postRelatorioDisponibilidadeResumidoInformacaoDiaCorrido(data) {
    return apiCallCenter().post('/relatorios/disponibilidade/operadores/resumido/dia-corrido?_method=GET', data)
  },

  exportExcel(params) {
    let query = `dataHoraInicio=${encodeURI(params.dataHoraInicio)}&dataHoraFim=${encodeURI(params.dataHoraFim)}`

    if(params.operadores.length == 0){
      query = `${query}&operadores[]=${params.operadores}`
    }else{
      params.operadores.forEach(operadores => {
        query = `${query}&operadores[]=${operadores}`
      })
    }

    const token = window.localStorage.getItem('pcm_access_token')
    query = `${query}&token=${token}`
    return `https://${hostname()}/backend/callcenter/relatorios/disponibilidade/resumido/export?${query}`
  },
}
